module.exports = __webpack_public_path__ + "img/oah-role-startup.55d6d926.svg";